module.exports = __webpack_public_path__ + "media/images/video-invite-icon-5865177793f0da5ae095415f4416c14a.svg";